import styled from 'styled-components';
import { Layout } from '@design-system';

export const CreatedAtContainer = styled(Layout.FlexCol)`
  white-space: nowrap;
  flex-wrap: nowrap;
  word-break: break-all;
`;
